import axios from "axios";
import Swal from "sweetalert2";

export const sendEmail = (data, alert) => {
    axios.post("https://service.codemontis.com/email/send-email/", {
        message: data?.message,
        to_email: data?.to_email,
        subject: data?.subject,
    }).then(res => {
        alert &&
            Swal.fire({
                title: "Thank you for your interest!",
                text: "Our agent will contact you soon!",
                icon: "success"
            });
    }).catch(err => { })
}

